import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  AccordionPanelProps,
  Grid,
  Text,
} from '@chakra-ui/react';
import React, { PropsWithChildren } from 'react';

import { useGlobalStateMachine } from '../../../../GlobalStore';
import { MasterContext } from '../../../MasterProvider';
import { useSizeContext } from '../../../SizeProvider';

/**
 * 共通プロパティ
 */
export type ItemCommonProps = AccordionPanelProps & {
  /**
   * フォームオブジェクト
   */
  isOutsourcer?: boolean;
  master: MasterContext;
  /**
   * 表示モード
   */
  mode?: 'edit' | 'view';
};

type InformationItemsProps = PropsWithChildren<
  AccordionPanelProps & {
    /**
     * セクション名
     */
    name: string;
    panelIndex: number;
  }
>;

/**
 * 個人情報アコーディオンアイテム
 * @param param0 -
 * @returns
 */
const InformationItems: React.FunctionComponent<InformationItemsProps> = ({
  children,
  hidden,
  name,
  panelIndex,
  ...props
}) => {
  const { actions } = useGlobalStateMachine();
  const sizes = useSizeContext();

  return (
    <AccordionItem
      width="100%"
      borderTop="none"
      borderBottomWidth="2px !important"
      borderBottomColor="gray.300"
      hidden={hidden}
    >
      <AccordionButton
        onClick={() =>
          actions.updatePageInfo({ USER_INFO: { openedPanel: panelIndex } })
        }
      >
        <Text
          flex="1"
          fontSize={sizes.fontSize.rawHeader}
          fontWeight="bold"
          textAlign="left"
        >
          {name}
        </Text>
        <AccordionIcon />
      </AccordionButton>
      <AccordionPanel {...props}>
        <Grid templateColumns={{ base: '1fr', md: '1fr 1fr' }} width="100%">
          {children}
        </Grid>
      </AccordionPanel>
    </AccordionItem>
  );
};

export default InformationItems;
